module.exports = __webpack_public_path__ + "img/more.553f3632.png";